import styled from "@emotion/styled";
import {JobLinksRenderer, TJobLinkItem} from "../../common/JobLinksRenderer";
import {ManifestStop} from "../../../generated/graphql";

export interface UnassignedManifestJobsContentProps {
  unassignedManifestJobIds: number[];
  manifestStopsMap: Record<number, ManifestStop[]>;
}

const UnassignedManifestJobsContent = ({
  unassignedManifestJobIds,
  manifestStopsMap
}: UnassignedManifestJobsContentProps) => {
  // Build a lookup of jobId -> { jobNumber, orderId } from manifestStopsMap
  const manifestJobsById = new Map<number, {jobNumber: string; orderId: number}>();
  for (const stops of Object.values(manifestStopsMap)) {
    for (const stop of stops) {
      if (!manifestJobsById.has(stop.job.jobId)) {
        manifestJobsById.set(stop.job.jobId, {
          jobNumber: stop.job.jobNumber,
          orderId: stop.order.orderId
        });
      }
    }
  }

  const jobLinks: TJobLinkItem[] = unassignedManifestJobIds.map((jobId) => {
    const info = manifestJobsById.get(jobId);
    return {
      jobNumber: info?.jobNumber ?? String(jobId),
      jobId,
      orderId: info?.orderId ?? 0
    };
  });

  return (
    <Container>
      <p>
        Optimization could not complete because {jobLinks.length === 1 ? "job" : "jobs"} {JobLinksRenderer(jobLinks)}{" "}
        started as assigned and there was no way to create a plan to meet the time windows of{" "}
        {jobLinks.length === 1 ? "this job" : "these jobs"} while meeting the time windows of all other jobs considered.
      </p>
      <p>Please make the necessary adjustments and try again.</p>
    </Container>
  );
};

export default UnassignedManifestJobsContent;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
